// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__19tPo","content":"styles_content__2LwQA","selectAll":"styles_selectAll__3aaYt"};